import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';

export function startTimeAfterMarketPeriodBuilder({parsedStatusObj}) {
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        Trade plan start time does not match the requested session. Start time:{' '}
        {parsedStatusObj.startHour != null && parsedStatusObj.startMin != null
          ? parsedStatusObj.startHour + ':' + parsedStatusObj.startMin
          : 'unknown'}
        . Requested session:{' '}
        {parsedStatusObj.desiredPeriod
          ? parsedStatusObj.desiredPeriod
          : 'unknown'}
        .
      </Body3>
    </td>
  );
}
